// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './vuex'
import mixin from './mixin'
import './assets/css/reset.css'
import './assets/fonts/iconfont.css'
import './assets/fonts_refund/iconfont.css'
import './assets/fonts_press/iconfont.css'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // token
    if (store.state.token) {
      config.headers.token = store.state.token
    }
    // 图书馆token
    if (store.state.libraryToken) {
      config.headers['Library-User-Token'] = store.state.libraryToken
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

// directive: v-loading
import Loading from '@/plugins/loading/Loading'
const LoadingConstructor = Vue.extend(Loading)
let instances = []
let instance
const slice = Array.prototype.slice
Vue.directive('loading', {
  bind: (el, binding) => {
    if (binding.value) {
      instance = new LoadingConstructor().$mount()
      el.appendChild(instance.$el)
      instances.push(instance)
    }
  },

  update: (el, binding) => {
    if (binding.value) {
      instance = new LoadingConstructor().$mount()
      el.appendChild(instance.$el)
      instances.push(instance)
    } else {
      let nodes = el.childNodes
      // ie兼容性处理
      let nodesArr = slice.call(nodes)
      let instancesArr = slice.call(instances)

      instancesArr.forEach(instance => {
        nodesArr.forEach(node => {
          if (instance.$el === node) {
            el.removeChild(instance.$el)
          }
        })
      })
    }
  }
})

/**
 * notify 插件
 * this.$notify(msg,type)
 *      msg: 提示信息, 可选, 默认:'成功'
 *      type: 消息类型(success error warning),可选, 默认:success
 */
import Notification from '@/plugins/notification'
const Cs = {}
Cs.install = Vue => {
  Vue.prototype.$notify = Notification
}
Vue.use(Cs)

// mixin
Vue.mixin(mixin)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js